export function Icons() {
  return <div className="flex flex-col gap-4"></div>
}

export function PlusIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 1.5C8.5 1.22386 8.27614 1 8 1C7.72386 1 7.5 1.22386 7.5 1.5V7.5H1.5C1.22386 7.5 1 7.72386 1 8C1 8.27614 1.22386 8.5 1.5 8.5H7.5V14.5C7.5 14.7761 7.72386 15 8 15C8.27614 15 8.5 14.7761 8.5 14.5V8.5H14.5C14.7761 8.5 15 8.27614 15 8C15 7.72386 14.7761 7.5 14.5 7.5H8.5V1.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ArrowIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.14645 2.64645C8.34171 2.45118 8.65829 2.45118 8.85355 2.64645L13.8536 7.64645C14.0488 7.84171 14.0488 8.15829 13.8536 8.35355L8.85355 13.3536C8.65829 13.5488 8.34171 13.5488 8.14645 13.3536C7.95118 13.1583 7.95118 12.8417 8.14645 12.6464L12.2929 8.5H2.5C2.22386 8.5 2 8.27614 2 8C2 7.72386 2.22386 7.5 2.5 7.5H12.2929L8.14645 3.35355C7.95118 3.15829 7.95118 2.84171 8.14645 2.64645Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TotalCasesIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9710)">
        <path
          d="M4 3.5C4 3.22386 4.22386 3 4.5 3H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H4.5C4.22386 4 4 3.77614 4 3.5Z"
          fill="currentColor"
        />
        <path
          d="M4.5 6C4.22386 6 4 6.22386 4 6.5C4 6.77614 4.22386 7 4.5 7H11.5C11.7761 7 12 6.77614 12 6.5C12 6.22386 11.7761 6 11.5 6H4.5Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5 16C0.671858 16 0 15.3281 0 14.5V1.5C0 0.671858 0.671858 0 1.5 0H14.5C15.3281 0 16 0.671858 16 1.5V14.5C16 15.3281 15.3281 16 14.5 16H1.5ZM1 1.5C1 1.22414 1.22414 1 1.5 1H14.5C14.7759 1 15 1.22414 15 1.5V9H10.5C10.2239 9 10 9.22386 10 9.5V12H6V9.5C6 9.22386 5.77614 9 5.5 9H1V1.5ZM10.5 13C10.7761 13 11 12.7761 11 12.5V10H15V14.5C15 14.7759 14.7759 15 14.5 15H1.5C1.22414 15 1 14.7759 1 14.5V10H5V12.5C5 12.7761 5.22386 13 5.5 13H10.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9710">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function UserIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 1C6.61929 1 5.5 2.11929 5.5 3.5C5.5 4.88071 6.61929 6 8 6C9.38071 6 10.5 4.88071 10.5 3.5C10.5 2.11929 9.38071 1 8 1ZM4.5 3.5C4.5 1.567 6.067 0 8 0C9.933 0 11.5 1.567 11.5 3.5C11.5 5.433 9.933 7 8 7C6.067 7 4.5 5.433 4.5 3.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.05025 10.5503C4.36301 9.2375 6.14348 8.5 8 8.5C9.85652 8.5 11.637 9.2375 12.9497 10.5503C14.2625 11.863 15 13.6435 15 15.5C15 15.6326 14.9473 15.7598 14.8536 15.8536C14.7598 15.9473 14.6326 16 14.5 16H1.5C1.36739 16 1.24021 15.9473 1.14645 15.8536C1.05268 15.7598 1 15.6326 1 15.5C1 13.6435 1.7375 11.863 3.05025 10.5503ZM8 9.5C6.4087 9.5 4.88258 10.1321 3.75736 11.2574C2.7506 12.2641 2.13856 13.5918 2.02085 15H13.9791C13.8614 13.5918 13.2494 12.2641 12.2426 11.2574C11.1174 10.1321 9.5913 9.5 8 9.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PhoneIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9825)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11ZM6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14C6.89543 14 6 13.1046 6 12Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.12037 8.1746C3.21536 8.06378 3.35404 8 3.5 8H12.5C12.646 8 12.7846 8.06378 12.8796 8.1746L15.8796 11.6746C15.9573 11.7652 16 11.8806 16 12V14C16 15.1041 15.1041 16 14 16H2C0.895858 16 0 15.1041 0 14V12C0 11.8806 0.0426961 11.7652 0.120372 11.6746L3.12037 8.1746ZM3.72997 9L1 12.185V14C1 14.5519 1.44814 15 2 15H14C14.5519 15 15 14.5519 15 14V12.185L12.27 9H3.72997Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 3.5C0 1.56686 1.56686 0 3.5 0H12.5C14.4331 0 16 1.56686 16 3.5V5.5C16 5.77614 15.7761 6 15.5 6H11.5C11.2239 6 11 5.77614 11 5.5V4H5V5.5C5 5.77614 4.77614 6 4.5 6H0.5C0.223858 6 0 5.77614 0 5.5V3.5ZM3.5 1C2.11914 1 1 2.11914 1 3.5V5H4V3.5C4 3.22386 4.22386 3 4.5 3H11.5C11.7761 3 12 3.22386 12 3.5V5H15V3.5C15 2.11914 13.8809 1 12.5 1H3.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9825">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function FavoriteIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9690)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.00001 0.366943C8.19032 0.366943 8.36413 0.474979 8.44837 0.645631L10.65 5.10594L15.5719 5.82114C15.7603 5.84851 15.9167 5.98043 15.9755 6.16145C16.0344 6.34246 15.9853 6.54116 15.849 6.674L12.2872 10.1455L13.1278 15.0485C13.16 15.236 13.0829 15.4256 12.9289 15.5375C12.7749 15.6493 12.5708 15.6641 12.4023 15.5755L8.00001 13.2608L3.5977 15.5755C3.42925 15.6641 3.22512 15.6493 3.07114 15.5375C2.91717 15.4256 2.84004 15.236 2.8722 15.0485L3.71279 10.1455L0.151026 6.674C0.0147301 6.54116 -0.0343268 6.34246 0.0244825 6.16145C0.0832917 5.98043 0.239767 5.84851 0.428114 5.82114L5.35 5.10594L7.55166 0.645631C7.6359 0.474979 7.80971 0.366943 8.00001 0.366943ZM8.00001 1.99657L6.13037 5.78426C6.05753 5.93181 5.91676 6.03408 5.75392 6.05775L1.57455 6.66505L4.599 9.61288C4.71685 9.72774 4.77063 9.89324 4.74282 10.0554L4.02901 14.2189L7.76733 12.2534C7.913 12.1768 8.08703 12.1768 8.2327 12.2534L11.971 14.2189L11.2572 10.0554C11.2294 9.89324 11.2832 9.72774 11.401 9.61288L14.4255 6.66505L10.2461 6.05775C10.0833 6.03408 9.9425 5.93181 9.86966 5.78426L8.00001 1.99657Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9690">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CreditIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9742)">
        <path
          d="M0.5 0C0.223858 0 0 0.223858 0 0.5C0 0.776142 0.223858 1 0.5 1H15.5C15.7761 1 16 0.776142 16 0.5C16 0.223858 15.7761 0 15.5 0H0.5Z"
          fill="currentColor"
        />
        <path
          d="M2.5 3C2.77614 3 3 3.22386 3 3.5V14.5C3 14.7759 3.22414 15 3.5 15H10V3.5C10 3.22386 10.2239 3 10.5 3C10.7761 3 11 3.22386 11 3.5V15H12.5C12.7759 15 13 14.7759 13 14.5V3.5C13 3.22386 13.2239 3 13.5 3C13.7761 3 14 3.22386 14 3.5V14.5C14 15.3281 13.3281 16 12.5 16H3.5C2.67186 16 2 15.3281 2 14.5V3.5C2 3.22386 2.22386 3 2.5 3Z"
          fill="currentColor"
        />
        <path
          d="M5.5 3C5.77614 3 6 3.22386 6 3.5V6.5C6 6.77614 5.77614 7 5.5 7C5.22386 7 5 6.77614 5 6.5V3.5C5 3.22386 5.22386 3 5.5 3Z"
          fill="currentColor"
        />
        <path
          d="M6 11.5C6 11.2239 5.77614 11 5.5 11C5.22386 11 5 11.2239 5 11.5V12.5C5 12.7761 5.22386 13 5.5 13C5.77614 13 6 12.7761 6 12.5V11.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9742">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function DocumentIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H11.5C11.7761 5 12 4.77614 12 4.5C12 4.22386 11.7761 4 11.5 4H4.5Z"
        fill="currentColor"
      />
      <path
        d="M4 7.5C4 7.22386 4.22386 7 4.5 7H11.5C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8H4.5C4.22386 8 4 7.77614 4 7.5Z"
        fill="currentColor"
      />
      <path
        d="M4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H6.5C6.77614 11 7 10.7761 7 10.5C7 10.2239 6.77614 10 6.5 10H4.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 0.5C1 0.223858 1.22386 0 1.5 0H14.5C14.7761 0 15 0.223858 15 0.5V10.5C15 10.6348 14.9467 10.7571 14.8599 10.8471L14.8536 10.8536L9.85355 15.8536L9.84706 15.8599C9.75714 15.9467 9.6348 16 9.5 16H1.5C1.22386 16 1 15.7761 1 15.5V0.5ZM9.5 10C9.22386 10 9 10.2239 9 10.5V15H2V1H14V10H9.5ZM13.2929 11L10 14.2929V11H13.2929Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LogoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 8H1" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" />
      <path d="M4.5 4.5L1 8L4.5 11.5" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" />
      <path
        d="M7.5 0.5H13.5C13.8978 0.5 14.2794 0.658035 14.5607 0.93934C14.842 1.22064 15 1.60218 15 2V14C15 14.3978 14.842 14.7794 14.5607 15.0607C14.2794 15.342 13.8978 15.5 13.5 15.5H7.5"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
    </svg>
  )
}

export function CogWheelIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99866 10.8564C9.57651 10.8564 10.8556 9.57726 10.8556 7.99929C10.8556 6.42133 9.57651 5.14215 7.99866 5.14215C6.42081 5.14215 5.14172 6.42133 5.14172 7.99929C5.14172 9.57726 6.42081 10.8564 7.99866 10.8564Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M14.4736 6.62043L13.6609 6.37668C13.5366 5.94271 13.3668 5.52857 13.152 5.14229L13.5532 4.39761C13.8548 3.83775 13.753 3.14607 13.3036 2.69659C12.8541 2.24709 12.1625 2.1453 11.6027 2.44693L10.858 2.8482C10.4713 2.63337 10.0571 2.463 9.62321 2.33924L9.37947 1.5265C9.19677 0.91735 8.63588 0.5 8 0.5C7.36412 0.5 6.80323 0.91735 6.62053 1.5265L6.37679 2.33924C5.94286 2.46353 5.52875 2.63337 5.14195 2.8482L4.39733 2.44693C3.83751 2.1453 3.14588 2.24709 2.69643 2.69659C2.24696 3.14607 2.14518 3.83775 2.44679 4.39761L2.84804 5.14229C2.63322 5.52911 2.46286 5.94325 2.33911 6.37668L1.52643 6.62043C0.91732 6.80314 0.5 7.36407 0.5 8C0.5 8.63593 0.91732 9.19686 1.52643 9.37957L2.33911 9.62332C2.46339 10.0573 2.63322 10.4714 2.84804 10.8577L2.44679 11.6024C2.14518 12.1623 2.24696 12.8539 2.69643 13.3034C3.14588 13.7529 3.83751 13.8547 4.39733 13.5531L5.14195 13.1518C5.52875 13.3666 5.94286 13.537 6.37679 13.6608L6.62053 14.4735C6.80323 15.0826 7.36412 15.5 8 15.5C8.63588 15.5 9.19677 15.0826 9.37947 14.4735L9.62321 13.6608C10.0571 13.5365 10.4713 13.3666 10.858 13.1518L11.6027 13.5531C12.1625 13.8547 12.8541 13.7529 13.3036 13.3034C13.753 12.8539 13.8548 12.1623 13.5532 11.6024L13.152 10.8577C13.3668 10.4709 13.5371 10.0568 13.6609 9.62332L14.4736 9.37957C15.0827 9.19686 15.5 8.63593 15.5 8C15.5 7.36407 15.0827 6.80314 14.4736 6.62043Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
    </svg>
  )
}

export function SupportIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9687)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
          fill="currentColor"
        />
        <path
          d="M8.00301 13C8.55529 13 9.00301 12.5523 9.00301 12C9.00301 11.4477 8.55529 11 8.00301 11C7.45072 11 7.00301 11.4477 7.00301 12C7.00301 12.5523 7.45072 13 8.00301 13Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.3582 3.51357C7.79512 3.44688 7.19016 3.62773 6.83498 3.94825C6.62997 4.13325 6.31381 4.11703 6.1288 3.91202C5.9438 3.70701 5.96002 3.39085 6.16503 3.20584C6.76285 2.66636 7.66689 2.42471 8.47581 2.52052C9.30118 2.61827 10.1338 3.08898 10.4051 4.0796C10.5684 4.67219 10.5068 5.15932 10.2947 5.58998C10.1164 5.95207 9.83485 6.25909 9.59257 6.52329C9.57125 6.54654 9.55023 6.56946 9.52961 6.59206C9.25808 6.88964 9.00863 7.1763 8.82 7.54448C8.63543 7.90472 8.5 8.36269 8.5 9.00005C8.5 9.27619 8.27615 9.50005 8 9.50005C7.72386 9.50005 7.5 9.27619 7.5 9.00005C7.5 8.2084 7.67121 7.59362 7.93001 7.08849C8.18475 6.59129 8.51542 6.21995 8.7909 5.91803C8.80188 5.906 8.81273 5.89411 8.82345 5.88237C9.09776 5.58188 9.28506 5.37673 9.39756 5.14824C9.49633 4.94764 9.54253 4.71316 9.44099 4.34496C9.30717 3.85591 8.9047 3.5783 8.3582 3.51357Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9687">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CarIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9780)">
        <path
          d="M4.00001 10C4.00001 10.5523 3.5523 11 3.00001 11C2.44773 11 2.00001 10.5523 2.00001 10C2.00001 9.44771 2.44773 9 3.00001 9C3.5523 9 4.00001 9.44771 4.00001 10Z"
          fill="currentColor"
        />
        <path
          d="M13 11C13.5523 11 14 10.5523 14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10C12 10.5523 12.4477 11 13 11Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.00639588 7.4199C0.001374 7.4506 -0.000696531 7.48131 1.3589e-05 7.51167V14.5C1.3589e-05 14.7761 0.223871 15 0.500014 15H4.50001C4.77616 15 5.00001 14.7761 5.00001 14.5V13H11V14.5C11 14.7761 11.2239 15 11.5 15H15.5C15.7762 15 16 14.7761 16 14.5V7.51168C16.0007 7.48131 15.9987 7.45059 15.9936 7.41987C15.9887 7.38916 15.9809 7.35938 15.9707 7.3308L14.2025 2.02623C13.9983 1.41219 13.4236 1 12.779 1H3.22101C2.57522 1 2.00174 1.41266 1.79756 2.02623L0.0293626 7.33081C0.0190882 7.35939 0.0113427 7.38918 0.00639588 7.4199ZM2.74647 2.34177C2.81438 2.13753 3.00493 2 3.22101 2H12.779C12.9944 2 13.1859 2.13815 13.2537 2.34211L14.8063 7H1.19373L2.74647 2.34177ZM12 13H15V14H12V13ZM15 12H1.00001V8H15V12ZM1.00001 13H4.00001V14H1.00001V13Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9780">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ArchiveIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9710)">
        <path
          d="M4 3.5C4 3.22386 4.22386 3 4.5 3H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H4.5C4.22386 4 4 3.77614 4 3.5Z"
          fill="currentColor"
        />
        <path
          d="M4.5 6C4.22386 6 4 6.22386 4 6.5C4 6.77614 4.22386 7 4.5 7H11.5C11.7761 7 12 6.77614 12 6.5C12 6.22386 11.7761 6 11.5 6H4.5Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5 16C0.671858 16 0 15.3281 0 14.5V1.5C0 0.671858 0.671858 0 1.5 0H14.5C15.3281 0 16 0.671858 16 1.5V14.5C16 15.3281 15.3281 16 14.5 16H1.5ZM1 1.5C1 1.22414 1.22414 1 1.5 1H14.5C14.7759 1 15 1.22414 15 1.5V9H10.5C10.2239 9 10 9.22386 10 9.5V12H6V9.5C6 9.22386 5.77614 9 5.5 9H1V1.5ZM10.5 13C10.7761 13 11 12.7761 11 12.5V10H15V14.5C15 14.7759 14.7759 15 14.5 15H1.5C1.22414 15 1 14.7759 1 14.5V10H5V12.5C5 12.7761 5.22386 13 5.5 13H10.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9710">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function HomeIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9741)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.68767 0.109566C7.87028 -0.0365219 8.12976 -0.0365219 8.31237 0.109566L15.8124 6.10957C16.028 6.28207 16.063 6.59672 15.8905 6.81235C15.7179 7.02798 15.4033 7.06294 15.1877 6.89043L8.00002 1.14031L0.812366 6.89043C0.596735 7.06294 0.282089 7.02798 0.109584 6.81235C-0.0629208 6.59672 -0.0279601 6.28207 0.187671 6.10957L7.68767 0.109566Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.50002 7C2.77616 7 3.00002 7.22386 3.00002 7.5V15H6.00002V11.5C6.00002 11.2239 6.22387 11 6.50002 11H9.50002C9.77616 11 10 11.2239 10 11.5V15H13V7.5C13 7.22386 13.2239 7 13.5 7C13.7762 7 14 7.22386 14 7.5V15.5C14 15.7761 13.7762 16 13.5 16H9.50002C9.22387 16 9.00002 15.7761 9.00002 15.5V12H7.00002V15.5C7.00002 15.7761 6.77616 16 6.50002 16H2.50002C2.22387 16 2.00002 15.7761 2.00002 15.5V7.5C2.00002 7.22386 2.22387 7 2.50002 7Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.00002 5.5C6.00002 5.22386 6.22387 5 6.50002 5H9.50002C9.77616 5 10 5.22386 10 5.5V8.5C10 8.77614 9.77616 9 9.50002 9H6.50002C6.22387 9 6.00002 8.77614 6.00002 8.5V5.5ZM7.00002 6V8H9.00002V6H7.00002Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9741">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CheckmarkIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3536 2.64645C15.5488 2.84171 15.5488 3.15829 15.3536 3.35355L5.35355 13.3536C5.15829 13.5488 4.84171 13.5488 4.64645 13.3536L0.646447 9.35355C0.451184 9.15829 0.451184 8.84171 0.646447 8.64645C0.841709 8.45118 1.15829 8.45118 1.35355 8.64645L5 12.2929L14.6464 2.64645C14.8417 2.45118 15.1583 2.45118 15.3536 2.64645Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PulseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.55456 2.003C6.76255 2.02583 6.93432 2.17576 6.98507 2.37875L9.65725 13.0675L12.0528 8.27641C12.1375 8.10702 12.3106 8.00001 12.5 8.00001H15.5C15.7761 8.00001 16 8.22387 16 8.50001C16 8.77616 15.7761 9.00001 15.5 9.00001H12.809L9.94721 14.7236C9.85364 14.9108 9.65343 15.0199 9.44544 14.997C9.23745 14.9742 9.06568 14.8243 9.01493 14.6213L6.34275 3.93255L3.94721 8.72362C3.86252 8.89301 3.68939 9.00001 3.5 9.00001H0.5C0.223858 9.00001 0 8.77616 0 8.50001C0 8.22387 0.223858 8.00001 0.5 8.00001H3.19098L6.05279 2.27641C6.14636 2.08926 6.34657 1.98017 6.55456 2.003Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PlugIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1545_9722)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.8535 0.146359C16.0488 0.341573 16.0489 0.658156 15.8536 0.853466L14.1603 2.54762C14.7018 3.24541 15.0002 4.10729 15.0002 4.99993C15.0002 6.05869 14.5804 7.07418 13.8331 7.82392L12.8623 8.84454C12.7694 8.94219 12.641 8.99821 12.5062 8.9999C12.3715 9.00158 12.2417 8.94879 12.1464 8.85349L7.17144 3.87849C6.97618 3.68323 6.97618 3.36664 7.17144 3.17138L8.17144 2.17138C8.92162 1.4212 9.93908 0.999756 11 0.999756C11.8931 0.999756 12.7554 1.29841 13.4533 1.8404L15.1464 0.146534C15.3416 -0.0487764 15.6582 -0.0488546 15.8535 0.146359ZM13.1038 2.86102C12.5429 2.30931 11.7874 1.99976 11 1.99976C10.2043 1.99976 9.44119 2.31585 8.87855 2.87849L8.2321 3.52493L12.491 7.78388L13.1213 7.12127C13.684 6.55863 14.0002 5.79563 14.0002 4.99993C14.0002 4.21294 13.691 3.45784 13.1398 2.89703C13.1336 2.89142 13.1275 2.88562 13.1215 2.87964C13.1154 2.87355 13.1095 2.86734 13.1038 2.86102Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.85267 7.85344C7.04787 7.65811 7.04776 7.34153 6.85244 7.14633C6.65711 6.95113 6.34053 6.95124 6.14533 7.14656L4.99988 8.29278L3.85355 7.14645C3.75825 7.05115 3.62851 6.99835 3.49375 7.00004C3.35898 7.00172 3.23061 7.05774 3.13772 7.15539L2.16688 8.17601C1.41955 8.92575 0.999817 9.94124 0.999817 11C0.999817 11.8927 1.29821 12.7546 1.83975 13.4524L0.146359 15.1467C-0.0488546 15.342 -0.0487764 15.6585 0.146534 15.8538C0.341844 16.049 0.658427 16.0489 0.853641 15.8536L2.54677 14.1596C3.24472 14.7016 4.10696 15.0002 5 15.0002C6.06091 15.0002 7.07837 14.5787 7.82855 13.8286L8.82855 12.8286C9.02381 12.6333 9.02381 12.3167 8.82855 12.1214L7.7071 11L8.85355 9.85355C9.04882 9.65829 9.04882 9.34171 8.85355 9.14645C8.65829 8.95118 8.34171 8.95118 8.14645 9.14645L7 10.2929L5.70699 8.99988L6.85267 7.85344ZM3.50894 8.21606L2.87866 8.87866C2.31602 9.44131 1.99982 10.2043 1.99982 11C1.99982 11.7957 2.31582 12.5578 2.87847 13.1205C3.44111 13.6831 4.2043 14.0002 5 14.0002C5.79569 14.0002 6.5588 13.6841 7.12144 13.1214L7.76789 12.475L3.50894 8.21606Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9722">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
